import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {api} from "../api";
import {AdminSessionFormField, PlainTeam, SessionSection} from "../../types/admin";

export type AdminSessionState = {
    loaded: boolean,
    error: string | null,
    date_start: string,
    date_end: string,
    duration: string,
    points: number,
    max_points: number,
    name: string,
    passed: boolean,
    sections: SessionSection[],
    form_fields: AdminSessionFormField[],
    user_id: string,
    game: string,
    game_id: string,
    game_version_id: string,
    state: string,
    live: boolean,
    teams: PlainTeam[]
}

const initialState: AdminSessionState = {
    loaded: false,
    error: null,
    date_start: '',
    date_end: '',
    duration: '',
    points: 0,
    max_points: 0,
    name: '',
    passed: false,
    sections: [],
    user_id: '',
    form_fields: [],
    game: '',
    game_id: '',
    game_version_id: '',
    state: '',
    live: false,
    teams: []
}

export const getAdminSession = createAsyncThunk(
    'adminSession/getAdminSession',
    async (session_id: string, thunkAPI) => {
        try {
            return await api.get(`/API/admin/sessions/${session_id}/`);
        } catch (error: any) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

export const slice = createSlice({
    name: 'adminSession',
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAdminSession.pending, (state) => {
                state.loaded = false;
                state.error = null;
            })
            .addCase(getAdminSession.fulfilled, (state, action) => {
                state.loaded = true;
                state.error = null;
                Object.assign(state, action.payload as AdminSessionState);
            })
            .addCase(getAdminSession.rejected, (state, action) => {
                state.loaded = true;
                if (typeof action.payload === 'string') {
                    state.error = action.payload as string;
                } else if (typeof action.error?.message === 'string') {
                    state.error = action.error.message;
                }
            })
    }
});

export default slice.reducer;